import { apiClient } from '@/core/apiClient';
import { publicClient } from '@/core/publicClient';

export type FooterItem = {
  id: string;
  label?: string;
  url?: string;
  image_path: string;
  is_active?: boolean;
  sort_order?: number;
};

export type FooterGroup = {
  id: string;
  slug: string;
  label: string;
  is_active?: boolean;
  sort_order?: number;
  items: FooterItem[];
};

export const footerApi = {
  // Admin groups
  listGroups: async (): Promise<FooterGroup[]> => {
    const res = await apiClient.get('/admin/footer/groups');
    return Array.isArray(res.data?.groups) ? res.data.groups : [];
  },
  createGroup: async (payload: { label: string; slug?: string; is_active?: boolean }) => {
    const res = await apiClient.post('/admin/footer/groups', payload);
    return res.data;
  },
  updateGroup: async (id: string, payload: { label?: string; slug?: string; is_active?: boolean }) => {
    const res = await apiClient.patch(`/admin/footer/groups/${id}`, payload);
    return res.data;
  },
  deleteGroup: async (id: string) => {
    const res = await apiClient.delete(`/admin/footer/groups/${id}`);
    return res.data;
  },
  reorderGroups: async (orderedIds: string[]) => {
    const res = await apiClient.post('/admin/footer/groups/reorder', { orderedIds });
    return res.data;
  },

  // Admin items
  listItems: async (groupId: string): Promise<FooterItem[]> => {
    const res = await apiClient.get(`/admin/footer/groups/${groupId}/items`);
    return Array.isArray(res.data?.items) ? res.data.items : [];
  },
  createItem: async (groupId: string, payload: FormData) => {
    const res = await apiClient.post(`/admin/footer/groups/${groupId}/items`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
  updateItem: async (id: string, payload: FormData | { label?: string; url?: string; is_active?: boolean }) => {
    if (payload instanceof FormData) {
      const res = await apiClient.patch(`/admin/footer/items/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return res.data;
    }
    const res = await apiClient.patch(`/admin/footer/items/${id}`, payload);
    return res.data;
  },
  deleteItem: async (id: string) => {
    const res = await apiClient.delete(`/admin/footer/items/${id}`);
    return res.data;
  },
  reorderItems: async (groupId: string, orderedIds: string[]) => {
    const res = await apiClient.post(`/admin/footer/groups/${groupId}/items/reorder`, { orderedIds });
    return res.data;
  },

  // Public
  getPublicFooter: async (): Promise<{ groups: FooterGroup[] }> => {
    const res = await publicClient.get('/public/footer');
    return { groups: Array.isArray(res.data?.groups) ? res.data.groups : [] };
  },
};
